export function XCircleIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            {/* Red gradient circle (matches Figma) */}
            <path
                d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                fill="url(#paint0_linear_3428_3734)"
            />

            {/* Inner X with light gradient (matches Figma) */}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.14645 9.14645C9.34171 8.95118 9.65829 8.95118 9.85355 9.14645L12 11.2929L14.1464 9.14645C14.3417 8.95118 14.6583 8.95118 14.8536 9.14645C15.0488 9.34171 15.0488 9.65829 14.8536 9.85355L12.7071 12L14.8536 14.1464C15.0488 14.3417 15.0488 14.6583 14.8536 14.8536C14.6583 15.0488 14.3417 15.0488 14.1464 14.8536L12 12.7071L9.85355 14.8536C9.65829 15.0488 9.34171 15.0488 9.14645 14.8536C8.95118 14.6583 8.95118 14.3417 9.14645 14.1464L11.2929 12L9.14645 9.85355C8.95118 9.65829 8.95118 9.34171 9.14645 9.14645Z"
                fill="url(#paint1_linear_3428_3734)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_3428_3734"
                    x1="6.5"
                    y1="5"
                    x2="17"
                    y2="20.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F83F54" />
                    <stop offset="1" stopColor="#CA2134" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_3428_3734"
                    x1="9.34835"
                    y1="12.2652"
                    x2="12.4726"
                    y2="15.5139"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FDFDFD" />
                    <stop offset="1" stopColor="#FECBE6" />
                </linearGradient>
            </defs>
        </svg>
    );
}